import setupWidgets from './widgets'

onDomLoad(function ($dom) {
  const exportForm = $dom.find('[data-behaviour="export-form"]')

  if (exportForm.length) {
    const unsubscriber = setupWidgets()

    $dom.one('turbolinks:before-visit', unsubscriber)
  }
})
